
export const Cexs = [
  {
    Address: "GALYJFJ5SVD45FBWN2GT4IW67SEZ3IBOFSBSPUFCWV427NBNLG3PXEQU",
    Rank: 4,
    Url: "https://www.okx.com/",
    SignUp: "https://www.okx.com/",
    Name: "OKX",
    Logo: "/assets/okx.png",
    Balance: 0,
  },
  {
    Address: "GDFNWH6ZFJVHJDLBMNOUT35X4EEKQVJAO3ZDL4NL7VQJLC4PJOQFWJ75",
    Rank: 6,
    Url: "https://bitget.com",
    SignUp: "https://bitget.com",
    Name: "Bitget",
    Logo: "/assets/bitget.png",
    Balance: 0,
  },
  {
    Address: "GD5HGPHVL73EBDUD2Z4K2VDRLUBC4FFN7GOBLKPK6OPPXH6TED4TRK73",
    Rank: 9,
    Url: "https://www.mexc.com",
    SignUp: "https://www.mexc.com",
    Name: "MEXC",
    Logo: "/assets/mexc.png",
    Balance: 0,
  },
  {
    Address: "GBC6NRTTQLRCABQHIR5J4R4YDJWFWRAO4ZRQIM2SVI5GSIZ2HZ42RINW",
    Rank: 11,
    Url: "https://www.gate.io",
    SignUp: "https://www.gate.io",
    Name: "Gate.io",
    Logo: "/assets/gate.png",
    Balance: 0,
  },
  {
    Address: "GD24QVE4R42E4XRDF6T5IN6UAQLD2WN7OQGUC2FBHFUUZM7GLE4KG6YA",
    Rank: 37,
    Url: "https://www.pionex.com",
    SignUp: "https://www.pionex.com",
    Name: "Pionex",
    Logo: "/assets/pionex.png",
    Balance: 0,
  },
  {
    Address: "GDL66HS4YTULXZ7NY7TZRUPCVD3BMANUIZUPCXU5HG46CVMI3YHBBWB6",
    Rank: 37,
    Url: "https://www.pionex.com",
    SignUp: "https://www.pionex.com",
    Name: "Pionex_2",
    Logo: "/assets/pionex.png",
    Balance: 0,
  },
  {
    Address: "GBXHS6NJONBIDPXRQ4T7ZHUAR3U2MFQBDNL267O7DXVP5UBZ2FWUX7YD",
    Rank: 17,
    Url: "https://www.lbank.com/",
    SignUp: "https://www.lbank.com/",
    Name: "Lbank",
    Logo: "/assets/lbank.png",
    Balance: 0,
  },
  {
    Address: "GATOC5LCD5PVVG4IDCRRURWJMN3R7RLEUJMGAYMA5DGIJP2D46HAXCMA",
    Rank: 14,
    Url: "https://www.kraken.com",
    SignUp: "https://www.kraken.com",
    Name: "Kraken",
    Logo: "/assets/kraken.png",
    Balance: 0,
  },
];